import React, { useContext, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import measureScrollbar from 'choerodon-ui/lib/_util/measureScrollbar';
import { pxToRem } from 'choerodon-ui/lib/_util/UnitConvertor';
import TableContext from './TableContext';
import { ColumnLock, DragColumnAlign } from './enum';
import TableEditor from './TableEditor';
import TableCol from './TableCol';
import { getColumnKey, isStickySupport } from './utils';
import { treeReduce } from '../_util/treeUtils';
const TableWrapper = observer(function TableWrapper(props) {
    const { children, hasBody, lock, hasHeader, hasFooter, columnGroups } = props;
    const { prefixCls, summary, tableStore } = useContext(TableContext);
    const { leafs, width } = columnGroups;
    const { overflowX, customizable, rowDraggable, dragColumnAlign } = tableStore;
    const hasPlaceHolder = lock !== ColumnLock.left && (hasHeader || hasFooter) && tableStore.overflowY;
    const tableWidth = overflowX ?
        lock !== ColumnLock.left && !hasBody && tableStore.overflowY ?
            pxToRem(width + measureScrollbar()) : pxToRem(width) : '100%';
    const editors = useMemo(() => hasBody ?
        treeReduce(leafs.map(({ column }) => column), (nodes, column) => {
            const { editor, name } = column;
            if (editor && name && (lock || isStickySupport() || !column.lock || !overflowX)) {
                nodes.push(React.createElement(TableEditor, { key: getColumnKey(column), column: column }));
            }
            return nodes;
        }, []) : undefined, [leafs, overflowX, lock, hasBody]);
    const colGroup = useMemo(() => {
        let fixedColumnLength = 1;
        if (customizable) {
            fixedColumnLength += 1;
        }
        if (rowDraggable && dragColumnAlign === DragColumnAlign.right) {
            fixedColumnLength += 1;
        }
        const cols = leafs.map(({ column, key }, index, array) => (React.createElement(TableCol, { key: key, column: column, last: !overflowX && index === array.length - fixedColumnLength })));
        if (hasPlaceHolder) {
            cols.push(React.createElement("col", { key: "fixed-column", style: { width: pxToRem(measureScrollbar()) } }));
        }
        return React.createElement("colgroup", null, cols);
    }, [leafs, customizable, rowDraggable, dragColumnAlign, hasPlaceHolder, overflowX]);
    const style = useMemo(() => ({ width: tableWidth }), [tableWidth]);
    const className = classNames({
        [`${prefixCls}-last-row-bordered`]: hasBody && !tableStore.overflowY && (tableStore.height !== undefined || (!tableStore.hasFooter && overflowX)),
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("table", { key: "table", className: className, style: style, summary: hasBody ? summary : undefined },
            colGroup,
            children),
        editors));
});
TableWrapper.displayName = 'TableWrapper';
export default TableWrapper;
